export default __webpack_public_path__ + "static/media/ellipse.66e8e4e2.png";